<template>
  <div class="main-content-wrapper">
    <div class="main-content-box px-3">
      <RevenueAndProfit />
    </div>

    <div class="main-content-box mt-1 p-3">
      <RevenueAndProfitLineChartContainer :title="translations('dashboard.performance_trend_chart')" />
    </div>
  </div>
</template>

<script>
import RevenueAndProfit from '@/components/dashboard/RevenueAndProfit.vue'
import RevenueAndProfitLineChartContainer from '@/components/dashboard/RevenueAndProfitLineChartContainer.vue'
import { mapState } from 'vuex'

export default {
  name: 'DashboardChart',
  components: {
    RevenueAndProfit,
    RevenueAndProfitLineChartContainer
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    }
  }
}
</script>

<style scoped>
.main-content-wrapper {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.main-content-box {
  background-color: #fff;
}
</style>
